export const SIGNATURE_INFO_SECTION = 'EE';
export const SUMMARY_SECTION = 'summary';
export const SECTION_A = 'A';
export const SECTION_AA = 'AA';
export const SECTION_B = 'B';
export const SECTION_C = 'C';
export const SECTION_CC = 'CC';
export const SECTION_D = 'D';
export const SECTION_DD = 'DD';
export const SECTION_E = 'E';
export const SECTION_EE = 'EE';
export const SECTION_F = 'F';
export const SECTION_H = 'H';
export const SECTION_I = 'I';
export const SECTION_J_ALL = 'J';
export const SECTION_J_CASH = 'J_Cash';
export const SECTION_J_EFT = 'J_EFT';
export const SECTION_J_PERIODIC = 'J_Periodic';
export const SECTION_J_TRANSFER = 'J_Transfer';
export const SECTION_J_PLUS = 'J+';
export const SECTION_L = 'L';
export const SECTION_M = 'M';
export const SECTION_N = 'N';
export const SECTION_O = 'O';
export const SECTION_P = 'P';
export const SECTION_Q = 'Q';
export const SECTION_R = 'R';
export const SECTION_S = 'S';
export const SECTION_T = 'T';
export const SECTION_U = 'U';
export const SECTION_V = 'V';
export const SECTION_W = 'W';
export const INITIAL_SECTION = SECTION_A;
